import { cloneDeep } from 'lodash-es';
import { getSpecialListValues } from '@gp/utils/common';
import { DEFAULT_FILTER } from '../models/locker';

import type { IRecord } from '@gp/types/global';
import type { ILockerData } from '../models/locker';

export const formatSearchProjectsResults = (searchResults: any) => {
  if (!Array.isArray(searchResults)) return [];
  return searchResults.map((item) => ({
    id: '',
    project_id: item?.project_id || '',
    studio_id: item?.studio_entity_id || '',
    name: item?.gameName || '',
    img: item?.headImgUrl || '',
    platform: item?.platformType || '',
  }));
};

export const analysisLockerData = (lockerData: ILockerData): ILockerData => {
  const { search: initialSearchData } = lockerData || {};
  const {
    search_type: initialSearchType,
    searchVal: initialSearchVal,
    searchList: initialSearchList,
  } = initialSearchData || {};
  const initialSearchListTmp = !!initialSearchType && !!initialSearchVal ? initialSearchList : [];
  const initialSearchDataTmp = { ...initialSearchData, searchList: initialSearchListTmp || [] };
  return { ...lockerData, search: initialSearchDataTmp };
};

export const formatSearchParams = (searchData?: IPipelineProjectListSearchVO | null): IPipelineProjectListSearchDTO => {
  const { search_type: searchType, search } = searchData || {};
  return { search_type: searchType || 'exact', search: search || [] };
};

export const formatFilterParams = (
  filter?: IPipelineProjectListFilterVO,
  filterConditions?: IRecord<IGPSelectOptionWithGroup[]>,
): IPipelineProjectListFilterVO => {
  if (!filter) return DEFAULT_FILTER;
  if (!filterConditions) return filter;
  const filterTmp = cloneDeep(filter);
  Object.keys(filterTmp).forEach((key) => {
    const options = filterConditions[key];
    const values = filterTmp[key as keyof IPipelineProjectListFilterVO];
    filterTmp[key as keyof IPipelineProjectListFilterVO] = getSpecialListValues(values, options, key);
  });
  return filterTmp;
};
